module.exports = "../../app/cells/pages/landing_xray/index/advantages_cell.rb";